export const publishServiceContent = [
  '',
  `mutation publishServiceContent($id:Int!) {
        publishServiceContent(id:$id)
    }
  `,
  'publishServiceContent'];
